var React = require('react');
var MedicalSchool = require('./ReactDependencies/MedicalSchool.jsx');
var Residency = require('./ReactDependencies/Residency.jsx');
var Fellowships = require('./ReactDependencies/Fellowships.jsx');
var Agreements = require('./ReactDependencies/Agreements.jsx');
var ChangeStepButtons = require('../ChangeStepButtons/changeStepButtons.jsx');
var selectableData = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableData.jsx');
var { $form } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');


class Step5 extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    bindFunctions() {
        this.allAgreementsMet = this.allAgreementsMet.bind(this);
        this.handleOtherInstitutionChange = this.handleOtherInstitutionChange.bind(this);
        this.institutionHasOther = this.institutionHasOther.bind(this);
        this.prevStepValid = this.prevStepValid.bind(this);
        this.nextStepValid = this.nextStepValid.bind(this);
        this.stateFieldIsRequired = this.stateFieldIsRequired.bind(this);
    }

    componentDidMount() {
        this.props.loadApiData('institutions');
        this.props.loadApiData('countriesAndStates');
        this.props.loadApiData('districts');
    }

    prevStepValid() {
        return this.props.appState.currentStep > 3 || this.props.appState.debugMode;
    }

    nextStepValid() {
        return (this.allAgreementsMet() && this.props.appState.currentStep < 6) || this.props.appState.debugMode;
    }

    allAgreementsMet() {
        return this.props.stepState.agreement1 && this.props.stepState.agreement2 && this.props.stepState.agreement3;
    }

    institutionHasOther(institutionName) {
        return institutionName && institutionName.indexOf(' - OTHER ') >= 0;
    }

    handleOtherInstitutionChange(countryCode, stateCode, programTypeCode, fieldToUpdate) {
        // find the corresponding institution from selectableData.institutions
        if (selectableData.institutions && selectableData.institutions.length) {
            var otherInst = selectableData.institutions.filter((inst) => {
                var stateMatch = stateCode === '' ? true : inst.State === stateCode;
                return inst.CountryCode === countryCode && stateMatch && inst.ProgramTypeCode === programTypeCode && inst.InstitutionName && inst.InstitutionName.indexOf(' - OTHER ') >= 0;
            });

            if (otherInst && otherInst.length) {
                this.props.updateStepState(fieldToUpdate, otherInst[0].InstitutionName);
            }
        }
    }

    stateFieldIsRequired(countryCode) {
        return ['USA', 'CAN'].includes(countryCode);
    }

    render() {
                
        return <div className={"step-5-container"}>

            <$form onSubmit={(event) => this.props.goToStep(event, 6)} ref={c => { this.form = c }}>
                <div className={'row'}>
                    <div className={'col-md-8'}>
                        <MedicalSchool handleOtherInstitutionChange={this.handleOtherInstitutionChange} stateFieldIsRequired={this.stateFieldIsRequired} institutionHasOther={this.institutionHasOther} {...this.props} />
                        <Residency handleOtherInstitutionChange={this.handleOtherInstitutionChange} stateFieldIsRequired={this.stateFieldIsRequired} institutionHasOther={this.institutionHasOther} {...this.props} />
                        <Fellowships handleOtherInstitutionChange={this.handleOtherInstitutionChange} stateFieldIsRequired={this.stateFieldIsRequired} institutionHasOther={this.institutionHasOther} {...this.props} />
                        <Agreements {...this.props} />
                    </div>
                    <div className={'col-md-4'}>
                        {this.props.cartComponent}
                    </div>
                </div>

                <ChangeStepButtons
                    disableUI={this.props.appState.disableUI}
                    nextStepValid={this.nextStepValid}
                    prevStepValid={this.prevStepValid}
                    goPrevStep={this.props.goPrevStep}
                    currentStep={this.props.appState.currentStep} />
            </$form>

        </div>;
    }
}

module.exports = Step5;